// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advancedSearchAddressField {
    width: 60%;
}

@media (max-width: 992px) {
    .advancedSearchAddressField {
        width: 100%;
    }
}

@media (max-width: 700px) {
    .advancedSearchAddressField {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/advancedSearch/AdvancedSearch.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".advancedSearchAddressField {\n    width: 60%;\n}\n\n@media (max-width: 992px) {\n    .advancedSearchAddressField {\n        width: 100%;\n    }\n}\n\n@media (max-width: 700px) {\n    .advancedSearchAddressField {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
